import React, { Component } from 'react'

class StepResults extends Component {
  componentWillUnmount() {
    const { trip } = this.props

    if (window.sessionStorage.getItem('quizz')) {
      const questions = JSON.parse(window.sessionStorage.getItem('quizz'))

      window.sessionStorage.setItem('quizz', JSON.stringify(questions.filter(question => question.id !== trip.id)))
    }
  }
  render() {
    const {
      questions,
      totalQuestions,
      trip: {
        acf: {
          end_message_game_trip: {
            successful_text,
            text_quizz_inferior_5,
            text_quizz_superior_5,
            title_score_quizz,
          }
        }
      }
    } = this.props
    const totalAnswers = questions.questions.filter(question => question.isRight).length
    const MAXIMAL_NOTE = 10
    const note = Math.ceil((totalAnswers / totalQuestions) * MAXIMAL_NOTE)

    return (
      <div className="trip__results">
        <div className="container">
          <div className="trip__title" dangerouslySetInnerHTML={{__html: successful_text}} />
          <div className="trip__text" dangerouslySetInnerHTML={{__html: title_score_quizz}} />
          <p className="trip__message" dangerouslySetInnerHTML={{__html: note > 5 ? text_quizz_superior_5 : text_quizz_inferior_5}} />

          <div className="trip__score">{`${note}/${MAXIMAL_NOTE}`}</div>
        </div>
      </div>
    )
  }
}
export default StepResults



// WEBPACK FOOTER //
// ./src/components/Step/StepResults/StepResults.js